module.exports = __webpack_public_path__ + "static/media/7-11.4d3a7ab7.png";